import { render, staticRenderFns } from "./BDXManagementTableExportButton.vue?vue&type=template&id=446a5dd0&scoped=true"
import script from "./BDXManagementTableExportButton.vue?vue&type=script&lang=js"
export * from "./BDXManagementTableExportButton.vue?vue&type=script&lang=js"
import style0 from "./BDXManagementTableExportButton.vue?vue&type=style&index=0&id=446a5dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446a5dd0",
  null
  
)

export default component.exports